import login from './login';
import common from './common';
import user from './user';
import user_list from './user_list';
import menu from './menu';
import lesson_list from './lesson_list';
import lesson from './lesson';
import lesson_video from './lesson_video';
import lesson_student from './lesson_student';
import lesson_coach from './lesson_coach';
import lesson_question from './lesson_question';
import forgot_password from './forgot_password';
import lesson_progress from './lesson_progress';
import reset_password from './reset_password';
import reset_password_success from './reset_password_success';
import version from './version';
import chat from './chat';
import gift_list from './gift_list';
import gift from './gift';
import graduation_list from './graduation_list';
import graduation from './graduation';
import plan_list from './plan_list';
import plan from './plan';
import payment_list from './payment_list';
import register_account from './register_account';
import user_management_list from './user_management_list';
import user_management from './user_management';
import profile from './profile';

const resources = {
  common,
  login,
  user,
  user_list,
  menu,
  lesson_list,
  lesson,
  lesson_video,
  lesson_student,
  lesson_coach,
  lesson_question,
  forgot_password,
  lesson_progress,
  reset_password,
  reset_password_success,
  version,
  chat,
  gift_list,
  gift,
  graduation_list,
  graduation,
  plan_list,
  plan,
  payment_list,
  register_account,
  user_management_list,
  user_management,
  profile,
};

export default resources;
